import styled from 'styled-components';

export const SearchViewContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1rem;
    overflow-y: scroll;
`;

export const ResultsHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 10rem;
    gap: 1rem;
`;

export const BannerContainer = styled.div`
    background-color: #f5f5f5;
    border-radius: 0.5rem;
    padding: 1rem;
    margin-bottom: 1rem;
`;

export const ResultColumns = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
`;

export const ResultField = styled.div`
    margin-bottom: 0.25rem;
`;
